import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import InfoUnavailable from '../../../../components/common/InfoUnavailable';

const Ingredients = forwardRef(function ({ ingredients }, ref) {
  return (
    <div ref={ref} className="mb-36 scroll-offset" id='ingredients-section'>
      <h4 className="accordion-header">Ingredients</h4>

      <div className="accordion-body">
        {ingredients?.length ? (
          <div>
            <div className="row">
              <div className="col-sm-6 col-lg-6 col-12 drug-info mb-0">
                <ul className="risk-list">
                  {ingredients.map((ingredient, index) => (
                    <li key={`ingredient-${index}`}>
                      <span className="label text-capitalize">{ingredient.IngredientDesc}</span>
                      <span
                        className={
                          'answer ' +
                          (ingredient.IngredientType === 'Active'
                            ? 'active'
                            : '')
                        }
                      >
                        {ingredient.IngredientType}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ) : (
          <InfoUnavailable />
        )}
      </div>
    </div>
  );
});

Ingredients.propTypes = {
  ingredients: PropTypes.array.isRequired,
};

Ingredients.displayName = 'Ingredients';

export default Ingredients;
